<template>
    <div class="scrollable only-y">
        <div class="page-header">
            <h1><i :class="'mdi mdi-' + $route.meta.icon"></i> {{ $route.name }}</h1>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">
                    <i class="mdi mdi-home-outline"></i>
                </el-breadcrumb-item>
                <el-breadcrumb-item>{{ $route.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="card-base card-shadow--medium p-30">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="24" :md="12" :lg="9" :xl="9">
                    <h2>Datos de registro</h2>
                    <el-form :model="form" ref="form" status-icon label-width="150px" size="medium" class="demo-form"
                        :rules="rules" label-position="top" v-loading="loadingForm">
                        <el-form-item label="Descripción" prop="description">
                            <el-input v-model="form.description" autocomplete="off" placeholder="Ingrese la descripción"
                                clearable>
                            </el-input>
                        </el-form-item>

                        <el-form-item class="btn-space">
                            <el-button type="primary" @click="submitForm('form')" :loading="loading" icon="el-icon-check"
                                v-if="!edit">Guardar</el-button>
                            <el-button type="warning" @click="submitForm('form')" :loading="loading" icon="el-icon-edit"
                                v-else>
                                Actualizar</el-button>
                            <el-button @click="resetForm('form')" icon="el-icon-close">Cancelar</el-button>
                        </el-form-item>
                    </el-form>
                </el-col>

                <!-- grid -->
                <el-col :xs="24" :sm="24" :md="12" :lg="15" :xl="15">
                    <el-table
                        :data="tableData.filter(data => !search || data.description.toLowerCase().includes(search.toLowerCase()))"
                        style="width: 100%; margin-top:20px;" height="500" v-loading="loadingTable">
                        <el-table-column label="Id" prop="id" width="80"></el-table-column>
                        <el-table-column label="Descripción" prop="description"></el-table-column>
                        <!-- <el-table-column align="right"> -->
                        <el-table-column align="right">
                            <template slot="header" slot-scope="scope">
                                <el-input v-model="search" size="mini" placeholder="Digite una descripción" />
                            </template>
                            <template slot-scope="scope">
                                <el-tooltip class="item" effect="dark" content="Editar" placement="top">
                                    <el-button size="mini" type="warning" @click="handleEdit(scope.row)" icon="el-icon-edit"
                                        circle></el-button>
                                </el-tooltip>
                                <el-tooltip class="item" effect="dark" content="Eliminar" placement="top">
                                    <el-button v-can="['admin']" size="mini" type="danger" @click="handleDelete(scope.row)"
                                        icon="el-icon-delete" circle></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import { getAll, save, update, edit, destroy } from '@/api/administration/costCenter.js'
export default {
    name: "cost-center",
    data() {
        return {
            loadingForm: false,
            loading: false,
            loadingTable: false,
            edit: false,
            form: {
                id: "",
                description: ""
            },
            rules: {
                description: [
                    {
                        required: true,
                        message: "Campo obligatorio",
                        trigger: "blur",
                    },
                ],
            },
            tableData: [],
            search: "",

        }
    },
    methods: {
        submitForm(form) {
            this.loading = true;
            this.$refs[form].validate((valid) => {
                if (valid) {
                    if (this.edit) {
                        this.updateForm();
                    } else {
                        this.saveForm();
                    }
                } else {
                    this.loading = false;
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        saveForm() {
            let me = this
            save(this.form.description)
                .then(({ data }) => {
                    this.loading = false;
                    if (data.code === 200) {
                        this.getTableData();
                        this.resetForm("form");
                        this.$message.success(data.msg)
                    } else {
                        this.$message.error("Error! " + data.error.errorInfo[2]);
                    }
                })
                .catch(function (error) {
                    me.loading = false;
                    console.log("Err: ", error);
                });
        },
        updateForm() {
            let me = this
            update(this.form.id, this.form.description)
                .then(({ data }) => {
                    this.loading = false;
                    if (data.code === 200) {
                        this.getTableData();
                        this.resetForm("form");
                        this.$message.success(data.msg)
                    } else {
                        this.$message.error("Error! " + data.error.errorInfo[2]);
                    }
                })
                .catch(function (error) {
                    me.loading = false;
                    console.log("Err: ", error);
                });
        },
        resetForm(form) {
            this.$refs[form].resetFields();
            this.loading = false;
            this.edit = false;
        },
        handleEdit(row) {
            this.loadingForm = true;
            edit(row.id)
                .then(({ data }) => {
                    this.edit = true;
                    this.loadingForm = false;
                    this.form = {
                        id: data.data.id,
                        description: data.data.description,
                    };
                    console.log(this.form, data);
                })
                .catch(function (error) {
                    console.log("Err: ", error);
                });
        },
        handleDelete(row) {
            let me = this
            this.$confirm("Desea eliminar este registro?", "Atención!", {
                confirmButtonText: "Si",
                cancelButtonText: "Cancelar",
                type: "warning",
            }).then(() => {
                destroy(row.id)
                    .then(({ data }) => {
                        this.loading = false;
                        if (data.code === 200) {
                            this.getTableData();
                            this.resetForm("form");
                            this.$message.success(data.msg)
                        } else {
                            this.$message.error("Error al eliminar categoría");
                        }
                    })
                    .catch(function (error) {
                        me.loading = false;
                        console.log("Err: ", error);
                    });
            })
                .catch(() => {
                    me.$message({
                        type: "info",
                        message: "Operación Cancelada",
                    });
                });
        },
        getTableData() {
            this.loadingTable = true;
            getAll()
                .then(({ data }) => {
                    this.loadingTable = false;
                    this.tableData = data;
                })
                .catch(function (error) {
                    this.loadingTable = false;
                    console.log(error);
                });
        },
    },
    created() {
        this.getTableData();
    },
}
</script>

//css 
<style lang="scss">
.btn-space {
    margin-top: 30px;
}
</style>